/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable prefer-arrow-callback */
/* eslint-disable no-restricted-syntax */
/* eslint-disable no-plusplus */
import Handlebars from "handlebars";
import jsonLogic from "json-logic-js";
import lod_ from "lodash";
import React from "react";

export function regexPhoneNumber(str) {
	const regex = /\+?\d{1,4}?[-.\s]?\(?\d{1,3}?\)?[-.\s]?\d{1,4}[-.\s]?\d{1,4}[-.\s]?\d{1,9}/g;
	return regex.test(str.trim().toLowerCase());
}

export function regexMail(str, regexEmail) {
	if (regexEmail) {
		let regexString = new RegExp(regexEmail);
		return regexString.test(str.trim().toLowerCase());
	} else {
		/* eslint-disable-next-line */
		return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,5}$/.test(str.trim().toLowerCase());
	}
}

export function generateRandomCode(length = 5) {
	let code = "";
	let possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
	for (let i = 0; i < length; i++) {
		code += possible.charAt(Math.floor(Math.random() * possible.length));
	}
	return code;
}

export const slugify = text => {
	return text
		.toString()
		.toLowerCase()
		.replace(/\s+/g, "-") // Replace spaces with -
		.replace(/[^\w-]+/g, "") // Remove all non-word chars
		.replace(/--+/g, "-") // Replace multiple - with single -
		.replace(/^-+/, "") // Trim - from start of text
		.replace(/-+$/, ""); // Trim - from
};

export function generateNameCode(text) {
	return `${slugify(text)}-${generateRandomCode()}`;
}

/**
 * Recursively removes keys with "undefined" values from an object, including nested objects.
 * @param {Object} obj - The input object to remove undefined keys from.
 */
function removeUndefinedKeys(obj) {
	for (const key in obj) {
		if (obj[key] === "undefined") {
			delete obj[key];
		} else if (typeof obj[key] === "object" && !Array.isArray(obj[key])) {
			// Recursively check nested objects
			removeUndefinedKeys(obj[key]);
		}
	}
}

// Define the custom json helper
Handlebars.registerHelper("json", function (text) {
	if (text === undefined) {
		// Unusual case, as undefined is not a possible JSON value
		// Make strong choice to replace with "undefined", later removed via removeUndefinedKeys
		return `null`;
	}
	return JSON.stringify(text);
});

/**
 * replaceInText replace tags like this <?tag.example> by the value in the context
 * @param {String} templateModel contains the template with possibly fields to replace
 * @param {Object} context an object with all value for replacement
 * @param {Boolean} isJson is true if the text is a json, usefull to treat string (add "" in json, not elsewhere)
 */
export function replaceInTextHbr(templateModel, context, isJson = false) {
	try {
		const template = Handlebars.compile(templateModel);
		const result = template(context);
		if (isJson) {
			const obj = JSON.parse(result);
			removeUndefinedKeys(obj);
			return obj;
		}
		return result;
	} catch (error) {
		return null;
	}
}

// This function returns the component information,
// including its name that is in variable 'REACT_APP_APPNAME' and the version 'REACT_APP_VERSION'.
export function getComponentInfo() {
	return `${process.env.REACT_APP_APPNAME}-${process.env.REACT_APP_VERSION}`;
}

export const getObjectDifference = (obj1, obj2, path = "") => {
	const diffs = [];

	// Get all unique keys from both objects
	const allKeys = lod_.union(lod_.keys(obj1), lod_.keys(obj2));

	allKeys.forEach(key => {
		const currentPath = path ? `${path}.${key}` : key;
		const val1 = obj1?.[key];
		const val2 = obj2?.[key];

		// Check if key exists in both objects
		const existsIn1 = lod_.has(obj1, key);
		const existsIn2 = lod_.has(obj2, key);

		// Key added
		if (!existsIn1 && existsIn2) {
			diffs.push({
				path: currentPath,
				type: "added",
				oldValue: undefined,
				newValue: val2
			});
			return;
		}

		// Key removed
		if (existsIn1 && !existsIn2) {
			diffs.push({
				path: currentPath,
				type: "removed",
				oldValue: val1,
				newValue: undefined
			});
			return;
		}

		// Both are arrays
		if (lod_.isArray(val1) && lod_.isArray(val2)) {
			if (!lod_.isEqual(val1, val2)) {
				// Check each array element
				const maxLength = Math.max(val1.length, val2.length);
				for (let i = 0; i < maxLength; i++) {
					const arrayPath = `${currentPath}[${i}]`;
					if (i >= val1.length) {
						diffs.push({
							path: arrayPath,
							type: "added",
							oldValue: undefined,
							newValue: val2[i]
						});
					} else if (i >= val2.length) {
						diffs.push({
							path: arrayPath,
							type: "removed",
							oldValue: val1[i],
							newValue: undefined
						});
					} else if (lod_.isObject(val1[i]) && lod_.isObject(val2[i])) {
						// Recursively compare object elements
						diffs.push(...getObjectDifference(val1[i], val2[i], arrayPath));
					} else if (!lod_.isEqual(val1[i], val2[i])) {
						diffs.push({
							path: arrayPath,
							type: "modified",
							oldValue: val1[i],
							newValue: val2[i]
						});
					}
				}
			}
			return;
		}

		// Both are objects (but not arrays)
		if (lod_.isPlainObject(val1) && lod_.isPlainObject(val2)) {
			diffs.push(...getObjectDifference(val1, val2, currentPath));
			return;
		}

		// Primitive values that differ
		if (!lod_.isEqual(val1, val2)) {
			diffs.push({
				path: currentPath,
				type: "modified",
				oldValue: val1,
				newValue: val2
			});
		}
	});

	return diffs;
};

export function replaceLogic(logic, inputs) {
	try {
		const replacedLogic = replaceInTextHbr(logic, inputs, true);
		return jsonLogic.apply(replacedLogic);
	} catch (error) {
		return null;
	}
}
